import ProductCard from "../../components/product-card/ProductCard";


const necklaces = [
  {
    id: 1,
    name: "Gold Minimal Necklace",
    price: 499,
    colors: [
      { name: "Gold", hex: "#D4AF37", image: "https://images.unsplash.com/photo-1617038260897-41a1f14a8ca0", stock: 5 }
    ]
  },
  {
    id: 2,
    name: "Layered Chain",
    price: 799,
    colors: [
      { name: "Gold", hex: "#D4AF37", image: "https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f", stock: 3 }
    ]
  }
];

export default function Necklaces({ addToCart }) {
  return (
    <div style={{ padding: "40px 20px" }}>
      <h1>Necklaces</h1>

      <div style={styles.grid}>
        {necklaces.map(p => (
          <ProductCard key={p.id} product={p} addToCart={addToCart} />
        ))}
      </div>
    </div>
  );
}

const styles = {
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "20px"
  }
};